import {Injectable, Injector} from "@angular/core";
import {ReportError} from "app/app.service";

import {BaseListService, BatchResponse} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";

@Injectable()
export class VmAgentsService extends BaseListService<Models.VirtualMachineAgentsListRequest, Models.BatchRequest, Models.VirtualMachineAgentSummary>
{

    constructor(inj: Injector)
    {
        super(inj, Models.VirtualMachineAgentSummary);
    }

    @ReportError
    public list(listReq: Models.VirtualMachineAgentsListRequest): Promise<Models.ListResponse>
    {
        return this.domain.apis.resource.listVirtualMachineAgentsDetails(listReq);
    }

    @ReportError
    protected getBatchResponseImpl(req: Models.BatchRequest): Promise<BatchResponse<Models.VirtualMachineAgentSummary>>
    {
        const batchRequest = Models.BatchRequest.newInstance({ids: req?.ids});

        return this.domain.apis.resource.batchVirtualMachineAgentsDetails(batchRequest);
    }

    protected createBatchRequest(listReq: Models.VirtualMachineAgentsListRequest,
                                 ids: string[]): Models.BatchRequest
    {
        return Models.BatchRequest.newInstance({ids: ids});
    }

    public async getAllData(listReq: Models.VirtualMachineAgentsListRequest): Promise<Models.VirtualMachineAgentSummary[]>
    {
        let res = await this.getAll(listReq);
        return res?.map(([id, summary]) => summary) || null;
    }
}
